import { render, staticRenderFns } from "./singleEduClassTest.vue?vue&type=template&id=6bb82543&"
import script from "./singleEduClassTest.vue?vue&type=script&lang=js&"
export * from "./singleEduClassTest.vue?vue&type=script&lang=js&"
import style0 from "./singleEduClassTest.vue?vue&type=style&index=0&id=6bb82543&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports